import StripeCustomer from '../../services/routes/user/stripecustomer';

const state = {
    data: null,
}
const mutations = {
    replaceStripeCustomer(state, customer) {
        return state.data = customer;
    },
    removeCard(state, cardId) {
        state.data.sources.data = state.data.sources.data.filter(source => source.id !== cardId);
    },
    newCard(state, card) {
        state.data.sources.data.push(card);
    },
    updateCustomer(state, data) {
        state.data[data.key] = data.value;
    }
}
const getters = {
    customer:  state => state.data,

}
const actions = {
    removeCard({commit}, data) {

    },
    fetchStripeCustomer({commit}) {
        StripeCustomer.get().then(result => {
            commit('replaceStripeCustomer', result.data);
        }).catch(error => {
            return;
        })

    }
};


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
